import React, { useState, useEffect } from "react";
// import "../Styles/globals.css";
import { toAbsoluteUrl } from "../../../toAbsoluteUrl.js";
import { callApi } from "../../../API.js";
import Pagination from "../../../Components/pagination.js";
import { useNavigate } from "react-router-dom";
import BreadcrumbsComponent from "../../../Components/Breadcrumbs.jsx";
// import WalletInformation from './components/walletInformation.jsx'
// import WalletTransaction from './components/walletTransaction.jsx'
// import OrdersAndReservations from './components/ordersAndReservation.jsx'





export default function TransactionDetails() {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState(0);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(0);
  const [data, setData] = useState([]);
  const [breadCrump, setBreadCrump] = useState([{name:'Home' ,link:'/'},{name : 'Finances',link:'businessDashboard/Finance'}]);
  
  function switchPageView(params) {
    if (activePage != params) {
      setActivePage(params);
    }
  }
  
  return (
    <div className="container">
      <BreadcrumbsComponent pages={breadCrump} />
        <div className="back-div">
        <img
                aria-expanded="false"
                src={toAbsoluteUrl("/media/images/back-arrow.svg")}
                alt="action-icon"
              />
              <p>Back</p>
        </div>
            <div className="download-section">
                <h1 className="sub-title">Transaction details</h1>
                <div className="d-flex gap-8">
                <img
                  className="notDark"
                  src={toAbsoluteUrl("/media/images/download-icon.svg")}
                  alt="download-icon"
                />
                 <img
                 className="darkMode"
                  src={toAbsoluteUrl("/media/images/download-icon-dark.svg")}
                  alt="download-icon"
                />
                  <p className="export-text">Download Receipt</p>
                </div>
            </div>
            <div className="transaction-details-card">
              <div className="col-md-3 col-7">
               <span>Transaction ID</span>
                <p>12345678910</p>
              </div>
              <div className="col-md-3 col-5">
               <span>Amount</span>
                <p>+300AED</p>
              </div>
              <div className="col-md-3 col-7">
               <span>Date & Time</span>
                <p>12/07/2024 - 12:30PM</p>
              </div>
              <div className="col-md-3 col-5">
               <span>Payment Method </span>
                <p>Wallet</p>
              </div>
              <div className="col-md-3 col-7">
               <span>Balance </span>
                <p>500AED</p>
              </div>

            </div>
        {loading == 1 ? (
          <div className="display-flex-with-center justify-content-center mt-5">
            <div class="spinner-border" role="status">
              <span class="sr-only"></span>
            </div>
          </div>
        ) : (
            <>
            
            {/* {activePage == 0 ?
                // <WalletTransaction />:
                // <OrdersAndReservations/>
            } */}
          </>
        )}
    </div>
  );
}
